import DeveloperModal from "./DeveloperModal";

export default DeveloperModal;